import { AuthService } from '@projects/core/auth/auth.service';
import { AppService } from '@ajin/services/app.service';
import { BooleanInput } from '@angular/cdk/coercion';
import { Component, inject, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { FuseConfig, FuseConfigService, Scheme } from '@fuse/services/config';

@Component({
	selector: 'auth-menu',
	templateUrl: './auth-menu.component.html',
	encapsulation: ViewEncapsulation.None,
	exportAs: 'user'
})
export class AuthMenuComponent implements OnInit, OnDestroy {
	/* eslint-disable @typescript-eslint/naming-convention */
	static ngAcceptInputType_showAvatar: BooleanInput;
	/* eslint-enable @typescript-eslint/naming-convention */
	config: FuseConfig;
	@Input() showAvatar: boolean = true;
	user: any;

	private unsubscribeAll: Subject<any> = new Subject<any>();
	private _router = inject(Router);

	constructor(
		public app: AppService,
		private _fuseConfigService: FuseConfigService,
		private authService: AuthService
	) {
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		this._fuseConfigService.config$
			.pipe(takeUntil(this.unsubscribeAll))
			.subscribe((config: FuseConfig) => {

				// Store the config
				this.config = config;
			});
	}


	ngOnDestroy(): void {

		this.unsubscribeAll.next(null);
		this.unsubscribeAll.complete();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Update the user status
	 *
	 * @param status
	 */
	updateUserStatus(status: string): void {
		// Return if user is not available
		if (!this.user) {
			return;
		}

		// Update the user
		// this._userService.update({
		//     ...this.user,
		//     status
		// }).subscribe();
	}

	/**
	 * Sign out
	 */
	signOut(): void {
		this.authService.signOut();
	}


	setScheme(scheme: Scheme): void {
		localStorage.setItem('scheme', scheme);
		this._fuseConfigService.config = { scheme };
	}


	resetPassword(): void {
		this._router.navigate(['reset-current-password']);
	}

}
